import { defineMessages } from "react-intl";

export const messages = defineMessages({
  channelName: {
    defaultMessage: "Channel name",
    id: "ChannelList/messages/vOL1vk",
    description: "label",
  },
});
